import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { CmsService } from '../shared/services/cms.service';
import {Router, ActivatedRoute, UrlSegment} from '@angular/router';
import { SeoService } from '../shared/services/seo.service';
import {Observable, Subscription} from "rxjs";

@Component({
    selector: 'mbnm-cms',
    providers: [CmsService],
    templateUrl: './cms.component.html',
    styleUrls: ['./cms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CmsComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cms: CmsService,
    public seoService: SeoService) {
  }

  cmsData:Array<any>;
  title:string;
  isBlog:boolean = false;
  subRef: Subscription;
  ngOnInit() {
    this.subRef = this.route.url
      .subscribe(url => {
        let slug = url[0].path;
        if (slug == 'blog') {
          this.title = "The Matboard and More Blog";
          this.isBlog = true;
          this.cms
            .posts(1)
            .then((postData) => {
              if (postData.total > 0) {
                this.cmsData = postData.posts;
              }
            }, (err) => {
              this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
            });
        } else {
          this.cms
            .pageChildren(slug)
            .then((page) => {
              this.cmsData = page.children;
              this.title = page.title;
              const first = this.cmsData ? this.cmsData[0] : null;
            }, (err) => {
              this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
            });
        }
      })
  }

  ngOnDestroy() {
    if (this.subRef && !this.subRef.closed) {
      this.subRef.unsubscribe();
    }
  }
}
